export enum Environment {
  Production = 'production',
  Beta = 'beta',
  Staging = 'staging',
  Test = 'test',
  CI = 'ci',
  Development = 'development',
}
